import React, { useEffect, useState } from "react";
import PageTitle from "Components/PageTitle/PageTitle";
import MuiPaper from "Components/MuiPaper/MuiPaper";
import InsertFomMastik from "./components/InsertFomMastik/InsertFomMastik";
import TblFomMastik from "./components/TblFomMastik/TblFomMastik";
import { GetAllFomMastik } from "Stores/actions";
import { read } from "Helpers/LocalStorage";
import { useDispatch, useSelector } from "react-redux";
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";
import Translator from "Languages/Utility/Translator";

function FomMastik() {
  const { fomMastikDataPagination } = useSelector((state) => ({
    fomMastikDataPagination: state.fomMastik.fomMastikDataPagination,
  }));
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const params = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
          Limit: fomMastikDataPagination.Limit,
          Page: fomMastikDataPagination.Page,
          Name: "",
        };
        await dispatch(GetAllFomMastik(params));
        setLoading(false);
      } catch (e) {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <>
      <BackDropLoading loading={loading} />
      <div className="page-top-title-button my-2">
        <PageTitle title={<Translator id={"FoamMastic"}/>} />
        <div className="top-buttons">
          {(read("fomMasticRules").accessRegister !== false) &&  <InsertFomMastik />}
        </div>
      </div>
      <MuiPaper className="mb-5">
        <TblFomMastik />
      </MuiPaper>
    </>
  );
}

export default FomMastik;
